<template>
  <div class="lookup-wrapper">
    <div class="lookup-hero" :style="{ backgroundImage: `url(${backgroundImage})` }">
      <div class="hero-content">
        <v-img :src="logo" height="65px" contain class="hero-logo" />
        <h1 class="hero-title">Find a business</h1>
        <p class="hero-subtitle">Enter the name of the business you'd like to join the rewards programme for</p>

        <v-card class="lookup-card" elevation="0">
          <v-card-text class="lookup-card-content">
            <v-form @submit.prevent="lookUpBusiness">
              <v-text-field
                v-model="businessId"
                label="Business name"
                required
                variant="outlined"
                color="rgb(0, 109, 62)"
                class="mb-2"
              />
              <v-btn
                type="submit"
                block
                class="find-btn"
              >
                Find business
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>

  <OverlayDialog
    v-model="showDialog"
    :title="dialogTitle"
    :message="dialogMessage"
    foregroundColor="rgb(0, 109, 62)"
    backgroundColor="white"
  />
</template>

<script>
import { ref } from "vue";
import { useRouter } from "vue-router";
import OverlayDialog from "@/components/Molecules/OverlayDialog.vue";
import { track } from "../../analytics.js";

export default {
  components: {
    OverlayDialog,
  },
  setup() {
    const router = useRouter();

    const showDialog = ref(false);
    const dialogTitle = ref("Invalid business name");
    const dialogMessage = ref("Please enter a valid business name");
    const businessId = ref("");
    const logo = require("@/assets/logo.png");
    const backgroundImage = require("@/assets/coffeeshop.jpg");

    const lookUpBusiness = () => {
      businessId.value = businessId.value
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9-]/g, "");

      if (businessId.value === "") {
        track("business_lookup_failed", { business_id: "", reason: "empty" });
        showDialog.value = true;
        return;
      }

      track("business_lookup", { business_id: businessId.value });
      router.push(`/business/${businessId.value}`);
    };

    return {
      showDialog,
      dialogTitle,
      dialogMessage,
      businessId,
      logo,
      backgroundImage,
      lookUpBusiness,
    };
  },
};
</script>

<style scoped>
.lookup-wrapper {
  width: 100%;
  font-family: 'Roboto', sans-serif;
}

.lookup-hero {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
  position: relative;
  padding: 20px;
}

.lookup-hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  pointer-events: none;
}

.hero-content {
  text-align: center;
  color: white;
  z-index: 5;
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10vh;
}

.hero-logo {
  margin-bottom: 28px;
  max-width: 120px;
}

.hero-title {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 16px;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  letter-spacing: -1px;
}

.hero-subtitle {
  font-size: 18px;
  font-weight: 300;
  margin-bottom: 36px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  line-height: 1.5;
  max-width: 400px;
}

.lookup-card {
  width: 100%;
  border-radius: 16px !important;
  background: white !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
}

.lookup-card-content {
  padding: 32px !important;
}

.find-btn {
  background: rgb(0, 109, 62) !important;
  color: white !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  border-radius: 999px !important;
  box-shadow: 0 2px 8px rgba(0, 109, 62, 0.2) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  text-transform: none !important;
  height: 48px !important;
}

.find-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 16px rgba(0, 109, 62, 0.3) !important;
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 36px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .lookup-card-content {
    padding: 24px !important;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 14px;
  }
}
</style>
